import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useLayoutEffect, useRef, useState } from 'react';

const Container = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100%;
  padding: ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.text.primary};
  padding-top: calc(env(safe-area-inset-top) + 44px);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.largeTitle};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  text-align: center;
  /* iOS原生文本样式 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  letter-spacing: -0.02em;
  line-height: 1.2;
`;

const Content = styled.div`
  max-width: 800px;
  text-align: center;
`;

const DebugPage = () => {
    const pageVariants = {
        initial: { opacity: 0, x: 100 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -100 }
    };
    const [safeAreaInfo, setSafeAreaInfo] = useState('');
    const safeAreaRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (safeAreaRef.current) {
            const style = getComputedStyle(safeAreaRef.current);
            const info = `
Safe Area Insets:
    Ref: ${safeAreaRef.current}
    Top: ${style.paddingTop}
    Bottom: ${style.paddingBottom}
    Left: ${style.paddingLeft}
    Right: ${style.paddingRight}
            `;
            setSafeAreaInfo(info);
        }
    }, []); // 空依赖数组

    return (
        <Container
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
            <Content>
                <Title>调试页面</Title>
                <div ref={safeAreaRef} style={{
                    paddingTop: 'env(safe-area-inset-top)',
                    paddingBottom: 'env(safe-area-inset-bottom)',
                    paddingLeft: 'env(safe-area-inset-left)',
                    paddingRight: 'env(safe-area-inset-right)',
                }}></div>
                <div>
                    <pre>{safeAreaInfo}</pre>
                </div>
            </Content>
        </Container>
    );
};

export default DebugPage;